import React, { useEffect, useState } from 'react';
import s from './ShoppingCart.module.scss';
import useIsAuth from 'sdk/hooks/useIsAuth';
import useGetOrders from 'sdk/hooks/shop/useGetOrders';
import useAddProductToBasket from 'sdk/hooks/shop/useAddProductToBasket';
import useRemoveProductFromBasket from 'sdk/hooks/shop/useRemoveProductFromBasket';
import useRemoveAllProduct from 'sdk/hooks/shop/useRemoveAllProduct';
import CartItemRow from './CartItemRow';

const CartItem = ({ open, data }) => {
  const { data: isAuthData } = useIsAuth();
  const userId = isAuthData?.user?.id;
  const { data: cartItems, refetch } = useGetOrders(userId || '');
  const { mutate: addToBasket } = useAddProductToBasket();
  const { mutate: removeFromBasket } = useRemoveProductFromBasket();
  const { mutate: removeAllProduct } = useRemoveAllProduct();

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    refetch();
  }, [open]);

const handlePlus = (item) => {
  if (!item.product) return;

  addToBasket(
    { createdBy: userId, productId: item.product.id, price: item.product.price },
    { onSuccess: () => refetch() }
  );
};

const handleMinus = (item) => {
  if (!item.product) return;

  removeFromBasket(
    { productId: item.product.id, userId }, // убрали price
    { onSuccess: () => refetch() }
  );
};

const handleRemoveItem = (item) => {
  setIsLoading(true);

  const payload = {
    userId,
    productId: item.product?.id ?? null,
    orderItemId: item.product ? null : item.id,  
  };

 if (!userId) return;  

removeAllProduct(
  {
    userId,
    productId: item.product?.id ?? null,
    orderItemId: item.product ? null : item.id,
  },
  {
    onSuccess: () => {
      refetch();
      setIsLoading(false);
    },
    onError: (error) => {
      console.error(error);
      setIsLoading(false);
    },
  }
);

};

 
  return (
    <div className={s.cart_item}>
      {data.map((item) => (
        <CartItemRow
          key={item.id}
          item={item}
          onPlus={() => handlePlus(item)}
          onMinus={() => handleMinus(item)}
          onRemove={() => handleRemoveItem(item)}
          isLoading={isLoading}
        />
      ))}
    </div>
  );
};

export default CartItem;
